import { render } from "./DiscussionList.vue?vue&type=template&id=29efba44"
import script from "./DiscussionList.vue?vue&type=script&lang=js"
export * from "./DiscussionList.vue?vue&type=script&lang=js"

import "./DiscussionList.vue?vue&type=style&index=0&id=29efba44&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__